// LazyImage.js
import { useEffect, useRef, useState } from "react";

const PLACEHOLDER_IMAGE = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

const LazyImage = ({ src, alt, ...props }) => {
 const [isIntersecting, setIsIntersecting] = useState(false); // 画像が表示されるかどうかのフラグ
 const imgRef = useRef(); // 画像の参照を保持するためのref

 useEffect(() => {
  // Intersection Observerの設定
  const observer = new IntersectionObserver(
   ([entry]) => {
    // 画像が表示されたときの処理
    if (entry.isIntersecting) {
     setIsIntersecting(true); // 画像が表示されたらフラグをtrueにする
     observer.disconnect(); // 監視を解除する
    }
   },
   {
    threshold: 0.1, // 画像が10%表示されたらコールバックを実行
   }
  );

  // 画像が表示されるまで監視する
  if (imgRef.current) {
   observer.observe(imgRef.current);
  }

  // クリーンアップ関数：コンポーネントのアンマウント時に実行
  return () => {
   if (imgRef.current) {
    observer.unobserve(imgRef.current);
   }
   observer.disconnect();
  };
 }, []);

 return <img ref={imgRef} src={isIntersecting ? src : PLACEHOLDER_IMAGE} alt={alt} className={`fade-in-image ${isIntersecting ? "is-visible" : ""}`} {...props} />;
};

export default LazyImage;
